
import store from '@/store';
import { defineComponent } from 'vue';
import { GlobalPagination } from '@/interfaces/panel/global-pagination.model';
import IpgTransactionSkelton from '@/components/transactionsComponents/IpgTransactionSkelton.vue';
import DepositTransferHistoryTable from '@/components/appComponents/DepositTransferHistoryTable.vue';
import CustomPaginationComponent from '@/components/appComponents/CustomPagination.vue';

export default defineComponent({
    name: "DepositTransferHistoryPage",

    components: { IpgTransactionSkelton, DepositTransferHistoryTable,  CustomPaginationComponent },

    data() {
        return {
            user: ""
        }
    },

    computed: {
        getLoadingPanel(): boolean {
            return store.getters["panel/getLoadingPanel"];
        },

        getDepositTRansferHistory() {
            return store.getters["panel/getDepositTRansferHistory"];
        },

        getGlobalPagination(): GlobalPagination {
            return store.getters["panel/getGlobalPagination"];
        }
    },

    methods: {
        handelPagination() {
            store.dispatch("panel/getDepositTransferHistoryRequest");
        }
    },

    mounted() {
        store.dispatch("panel/getDepositTransferHistoryRequest");
    }
})
